import { Icon } from "../ui/Icon";

export type RaceLinkData = {
  name: string;
  icon: string | null;
};

export function RaceLink(props: { race: RaceLinkData }) {
  const race = props.race;
  return (
    <span
      style={{
        whiteSpace: "nowrap",
        display: "inline-flex",
        alignItems: "center",
        columnGap: 2,
        verticalAlign: "bottom",
      }}
    >
      {race.icon && <Icon icon={race.icon} size={16} />}
      <span>{race.name}</span>
    </span>
  );
}
